/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRecordingResponse
 */
export interface CreateRecordingResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CreateRecordingResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingResponse
     */
    status: CreateRecordingResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingResponse
     */
    recordingId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingResponse
     */
    documentId?: string | null;
    /**
     * Optional: present only when a release was linked or created.
     * @type {string}
     * @memberof CreateRecordingResponse
     */
    releaseId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRecordingResponse
     */
    errors?: Array<string>;
}


/**
 * @export
 */
export const CreateRecordingResponseStatusEnum = {
    Created: 'created',
    Invalid: 'invalid',
    Failed: 'failed',
    NotImplemented: 'not_implemented'
} as const;
export type CreateRecordingResponseStatusEnum = typeof CreateRecordingResponseStatusEnum[keyof typeof CreateRecordingResponseStatusEnum];


/**
 * Check if a given object implements the CreateRecordingResponse interface.
 */
export function instanceOfCreateRecordingResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function CreateRecordingResponseFromJSON(json: any): CreateRecordingResponse {
    return CreateRecordingResponseFromJSONTyped(json, false);
}

export function CreateRecordingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRecordingResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'status': json['status'],
        'recordingId': !exists(json, 'recording_id') ? undefined : json['recording_id'],
        'documentId': !exists(json, 'document_id') ? undefined : json['document_id'],
        'releaseId': !exists(json, 'release_id') ? undefined : json['release_id'],
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
    };
}

export function CreateRecordingResponseToJSON(value?: CreateRecordingResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'status': value.status,
        'recording_id': value.recordingId,
        'document_id': value.documentId,
        'release_id': value.releaseId,
        'errors': value.errors,
    };
}

